var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"pill":"","variant":"primary"},on:{"click":_vm.openModal}},[_c('b-icon-info-circle'),_c('span',{staticClass:"d-none d-md-inline"},[_vm._v(" Information")]),_c('InformationDialog',{ref:"informationDialog"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }